import { PROMOACTION_TYPES_LIST } from './constants';
import { type PromoactionType } from './types';

export function isPromoactionType(status?: string): status is PromoactionType {
    return PROMOACTION_TYPES_LIST.includes(status as PromoactionType);
}
